import 'hammerjs';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { first } from 'rxjs/operators';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { ConnectionCheck } from './app/utils/connection-check';

if (environment.production) {
  enableProdMode();
}

ConnectionCheck.checkConnection();
ConnectionCheck.isConnection$.pipe(first()).subscribe(() => {
  platformBrowserDynamic().bootstrapModule(AppModule);
});
